/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout(payload = {}) {
    return axios.post(`${this.url}checkout`, payload);
  }

  subscription(payload = {}) {
    return axios.post(`${this.url}subscription`, payload);
  }

  getLimits() {
    return axios.get(`${this.url}limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits, providerKey) {
    const payload = { credits };
    if (providerKey) {
      payload.provider_key = providerKey;
    }

    return axios.post(`${this.url}topup_checkout`, payload);
  }
}

export default new EnterpriseAccountAPI();
